"use client";
import dynamic from "next/dynamic";

const FeatureVideo = dynamic(() => import("./FeatureVideo"), {
  ssr: false,
});

const AllInOneVideoWrapper = () => {
  return <FeatureVideo />;
};

export default AllInOneVideoWrapper;
